export default "__VITE_ASSET__e0c437ee__"